import { Link } from 'react-router-dom';

import {
  ADD_CATEGORY_LABEL,
  ADD_CLIENT_SERVICES_LABEL,
  ADD_CLIENT_SERVICES_PATH,
  ADD_SERVICE_CATEGORY_PATH,
  CATEGORY_ADDITION_KEY,
  SERVICES_EXPORT_KEY,
  SERVICES_IMPORT_KEY,
  SERVICES_IMPORT_TEMPLATE_KEY,
  SERVICE_ADDITION_KEY,
} from '@app/constants';

import { ServicesImport } from '@pages/Clients/ServicesSorting/components/ServicesImport';

import type { NServicesSorting } from '@pages/Clients/ServicesSorting/ServicesSorting.types';

import type { MenuProps } from 'antd';
import type { ReactNode } from 'react';

type ExportServiceId = {
  Id: number;
};

type CreateServicesSortingMenuItemsArgs = {
  services: NServicesSorting.ServiceRow[];
  hasUserRightToExport: boolean;
  hasUserRightToImport: boolean;
  hasUserRightToCreateCategory?: boolean;
  hasUserRightToCreateService?: boolean;
  exportToExcelByIds: (ids: ExportServiceId[]) => void | Promise<void>;
  importInputId: string;
  exportLabel?: ReactNode;
  includeCreationActions?: boolean;
  onExportTemplateClick: () => void;
};

export const getServiceIdsToExport = (
  services: NServicesSorting.ServiceRow[]
): ExportServiceId[] => {
  return (services || []).map(({ key }: NServicesSorting.ServiceRow) => ({
    Id: Number(key),
  }));
};

export const createServicesSortingMenuItems = ({
  services,
  hasUserRightToExport,
  hasUserRightToImport,
  hasUserRightToCreateCategory = false,
  hasUserRightToCreateService = false,
  exportToExcelByIds,
  importInputId,
  exportLabel = 'Экспорт в файл',
  includeCreationActions = false,
  onExportTemplateClick,
}: CreateServicesSortingMenuItemsArgs): MenuProps['items'] => {
  return [
    ...(hasUserRightToExport
      ? [
          {
            key: SERVICES_EXPORT_KEY,
            label: exportLabel,
            onClick: () => exportToExcelByIds(getServiceIdsToExport(services)),
          },
        ]
      : []),
    ...(hasUserRightToImport
      ? [
          {
            key: SERVICES_IMPORT_TEMPLATE_KEY,
            label: (
              <span
                className="unselectable"
                data-testid="export-services-template"
              >
                Выгрузить шаблон создания услуг
              </span>
            ),
            onClick: onExportTemplateClick,
          },
        ]
      : []),
    ...(hasUserRightToImport
      ? [
          {
            key: SERVICES_IMPORT_KEY,
            label: <ServicesImport inputId={importInputId} />,
          },
        ]
      : []),
    ...(includeCreationActions && hasUserRightToCreateCategory
      ? [
          {
            key: CATEGORY_ADDITION_KEY,
            label: (
              <Link to={ADD_SERVICE_CATEGORY_PATH}>{ADD_CATEGORY_LABEL}</Link>
            ),
          },
        ]
      : []),
    ...(includeCreationActions && hasUserRightToCreateService
      ? [
          {
            key: SERVICE_ADDITION_KEY,
            label: (
              <Link to={ADD_CLIENT_SERVICES_PATH}>
                {ADD_CLIENT_SERVICES_LABEL}
              </Link>
            ),
          },
        ]
      : []),
  ];
};
